import ProductTypeInList from './ProductTypeInList'

const ProductTypesList = ({productTypeList, inputValue, setProductType, productNameFiled}) => {
    return (
        <div 
            className='flex flex-col w-full max-h-24 overflow-auto' 
            style={{
                border: "1px solid rgba(163, 163, 163, 0.33)",
                maxWidth: "400px"
            }}
        >
            {
                productTypeList.map((product, index) => 
                    <ProductTypeInList product={product} inputValue={inputValue} setProductType={setProductType} key={index} productNameFiled={productNameFiled}/>
                )
            }
        </div>
    )
}

export default ProductTypesList